'use strict';

import template from './rating.html';

const STARS = [1, 2, 3, 4, 5];
const saRating = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {
        rating: '='
      },
      link: function ($scope) {
        $scope.stars = STARS;
      }
    };
  }
];

export default saRating;



// WEBPACK FOOTER //
// ./app/src/directives/rating.js